/**
 * From this width the header bar has room for the language and theme
 * selectors; below it they are in the user menu.
 */
export const HEADER_SELECTORS_IN_BAR = '@media (min-width: 1440px)';
